import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as CompanyTypeService from '@/services/company-type.service';
import { ICompanyType } from '@/domain/company-type.model';

@Options({
  name: 'company-type-edit',
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class CompanyTypeNew extends Vue {
  public id: string;
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row: ICompanyType = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    CompanyTypeService.get(this.id)
      .then((res: ICompanyType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }

  public goBack() {
    this.$router.push('/company-type');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      CompanyTypeService.update({
        id: parseInt(this.id),
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/company-type');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
